import job from "../../assets/job.png";
import company from "../../assets/company.png";
import analytics from "../../assets/analytics.png";
import mitarbeiterImg from "../../assets/Mitarbeiter.png";
import performanceImg from "../../assets/Performance.png";
import socialImg from "../../assets/Social.png";
import wzCodesImg from "../../assets/Wzcodes.png";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useState } from "react";

function Features() {
  // Hook
  const { t } = useTranslation();
  const [modalVideo, setModalVideo] = useState(null);
  // helper to build public asset URLs that respect Vite base path and encode segments
  const publicUrl = (relativePath) => {
    const base = import.meta.env.BASE_URL || "/";
    const segments = relativePath.replace(/^\//, "").split("/").map(encodeURIComponent);
    return `${base}${segments.join("/")}`;
  };

  const featuresData = [
    {
      id: 1,
      img: job,
      title: t("fCard1Heading"),
      desc: t("fCard1Desc"),
    },
    {
      id: 2,
      img: company,
      title: t("fCard2Heading"),
      desc: t("fCard2Desc"),
    },
    {
      id: 3,
      img: analytics,
      title: t("fCard3Heading"),
      desc: t("fCard3Desc"),
    },
  ];

  return (
    <>
      <div className="bg-[#F9F9FB]">
      {/* Team/Mitarbeiter Section */}
      <div className="w-full md:mt-24 mt-16 md:mb-20 mb-10">
        <div className="project-container m-auto w-full h-full px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-4">
            {/* Left side - Image */}
            <div className="w-full lg:w-7/12">

              <div className="relative w-fit max-w-full mx-auto mt-20 overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center p-2">
                <img
                  src={mitarbeiterImg}
                  alt="Mitarbeiter bei Jobdaten"
                  className="w-auto max-w-full h-auto max-h-[480px] object-contain border border-gray-100 rounded-lg"
                />
              </div>
            </div>

            {/* Right side - Text */}
            <div className="w-full lg:w-6/12">
              <span className="inline-block px-3 py-1 rounded-full bg-purple-100 text-[#8B5FFF] text-xs font-bold uppercase tracking-wide mb-4">
                Entscheiderdaten
              </span>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-center lg:text-left">
                Entscheiderdaten auf Knopfdruck
              </h3>
              <p className="text-lg text-[#A6A6A6] text-center lg:text-left mb-6">
                Die Entscheider zu jeder Jobanzeige direkt in der Software. Mit nur einem Klick erhältst du die Kontaktdaten der richtigen Ansprechpartner – für eine direkte und persönliche Kontaktaufnahme. Kein manuelles Suchen mehr auf Unternehmenswebseiten oder in sozialen Netzwerken: Unsere KI recherchiert die passenden Ansprechpartner automatisch und liefert dir Name, Position und Kontaktmöglichkeit direkt zur jeweiligen Stellenanzeige.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>KI integriert:</strong> Datenaufbereitung mittels KI, ohne manuellen Rechercheaufwand</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Live:</strong> Daten innerhalb weniger Sekunden verfügbar</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Direkter Kontakt:</strong> Name, Position und Kontaktweg der richtigen Ansprechpartner auf einen Blick</span>
                </li>
              </ul>
              <div className="text-center lg:text-left">
                <a href="/demo">
                  <button className="px-8 py-3 text-white font-semibold rounded-full bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                    Jetzt kostenlos testen
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Social Links Video Section */}
      <div className="w-full md:mt-28 mt-10 md:mb-20 mb-10 bg-white py-10 md:py-14">
        <div className="project-container m-auto w-full h-full px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left side - Text */}
            <div className="w-full lg:w-6/12">
              <span className="inline-block px-3 py-1 rounded-full bg-purple-100 text-[#8B5FFF] text-xs font-bold uppercase tracking-wide mb-4">
                Social Links
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center lg:text-left">
                Social Links für besseres Recruiting
              </h2>
              <p className="text-lg text-[#A6A6A6] text-center lg:text-left mb-6">
                Nutze die Power von LinkedIn und XING um direkt die richtigen
                Ansprechpartner zu finden. Unsere Social Links-Funktion
                verbindet Jobanzeigen mit den entsprechenden Recruitern und
                HR-Managern für eine direkte und persönliche Kontaktaufnahme.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Direkter Zugriff:</strong> auf LinkedIn- und XING-Profile der Entscheider.</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Schnellere Kontaktaufnahme:</strong> ohne mühsames Nachschlagen von Ansprechpartnern.</span>
                </li>
              </ul>
              <div className="text-center lg:text-left">
                <a href="/demo">
                  <button className="px-8 py-3 text-white font-semibold rounded-full bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                    Social Links entdecken
                  </button>
                </a>
              </div>
            </div>

            {/* Right side - Image (replaces Social Links Video) */}
            <div className="w-full lg:w-6/12">
              <div className="relative w-full rounded-lg shadow-lg overflow-hidden bg-white border border-gray-200 flex items-center justify-center p-2">
                <img
                  src={socialImg}
                  alt="Social Links"
                  className="w-full h-auto max-h-[560px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* KI Unternehmensinfos Video Section */}
      <div className="w-full md:mt-16 mt-10 md:mb-20 mb-10">
        <div className="project-container m-auto w-full h-full px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left side - Image (replaces KI Video) */}
            <div className="w-full lg:w-6/12">
              <div
                className="relative w-full h-[420px] md:h-[560px] mb-20 rounded-lg shadow-lg overflow-hidden bg-white border border-gray-200 flex items-center justify-center"
                onClick={() => setModalVideo("ai-company")}
              >
                <img
                  src={performanceImg}
                  alt="Performance"
                  className="max-w-full max-h-full w-auto h-auto object-contain"
                />
              </div>
            </div>

            {/* Right side - Text */}
            <div className="w-full lg:w-6/12">
              <span className="inline-block px-3 py-1 rounded-full bg-purple-100 text-[#8B5FFF] text-xs font-bold uppercase tracking-wide mb-4">
                KI-Feature
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center lg:text-left">
                KI-gestütztes CV Matching
              </h2>
              <p className="text-lg text-[#A6A6A6] text-center lg:text-left mb-6">
                Gleiche Lebensläufe mit den Anforderungen der Jobanzeigen ab und finde die besten Kandidaten für deine offenen Positionen. Unsere KI analysiert die Lebensläufe und identifiziert die relevantesten Informationen und gleicht Sie mit dem Jobangebot ab, um dir bei Kundengesprächen alle Informationen zu liefern die du brauchst.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Fahrtweg und Qualifikationsabgleich:</strong> auf einen Blick statt mühsamer Recherche.</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>gezielte Argumentation:</strong> Generiert passgenaue Argumentationen um Kundengespräche zu unterstützen.</span>
                </li>
              </ul>
              <div className="text-center lg:text-left">
                <a href="/demo">
                  <button className="px-8 py-3 text-white font-semibold rounded-full bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                    KI-Features testen
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Unternehmensdatenbank / WZ-Codes Section */}
      <div className="w-full md:mt-16 mt-10 md:mb-20 mb-10 bg-white py-10 md:py-14">
        <div className="project-container m-auto w-full h-full px-4">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left side - Text */}
            <div className="w-full lg:w-6/12">
              <span className="inline-block px-3 py-1 rounded-full bg-purple-100 text-[#8B5FFF] text-xs font-bold uppercase tracking-wide mb-4">
                Unternehmensdatenbank
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center lg:text-left">
                Alle Unternehmen erfasst – gefiltert nach deinen Kriterien
              </h2>
              <p className="text-lg text-[#A6A6A6] text-center lg:text-left mb-6">
                Wir erfassen alle Unternehmen in unserer Datenbank und ermöglichen dir eine gezielte Filterung nach Mitarbeiterzahl, Umsatzvolumen und Branche (WZ-Code). So findest du in Sekunden genau die Firmen, die zu deiner Zielgruppe passen.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Branchenfilter:</strong> Suche gezielt nach Branche oder WZ-Code.</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Mitarbeiterzahl:</strong> Filtere Unternehmen nach Firmengröße, von 1-10 bis 1001+ Mitarbeiter.</span>
                </li>
                <li className="flex items-start gap-3 justify-center lg:justify-start">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center mt-0.5">✓</span>
                  <span className="text-left"><strong>Umsatzvolumen:</strong> Sortiere nach Umsatz, von 1-10 Mio € bis 500+ Mio €.</span>
                </li>
              </ul>
              <div className="text-center lg:text-left">
                <a href="/demo">
                  <button className="px-8 py-3 text-white font-semibold rounded-full bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                    Firmenfilter entdecken
                  </button>
                </a>
              </div>
            </div>

            {/* Right side - Image */}
            <div className="w-full lg:w-6/12">
              <div className="relative w-full rounded-lg overflow-hidden bg-white flex items-center justify-center p-2">
                <img
                  src={wzCodesImg}
                  alt="Firmenfilter nach Mitarbeiterzahl, Umsatz und WZ-Codes"
                  className="w-full h-auto max-h-[560px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      </div>

      <div className="w-full md:mt-56 mt-10 md:mb-20 mb-10" id="features">
        <div className="project-container m-auto w-full h-full px-4">
          {/* Section Header */}
          <div className="md:flex md:justify-between md:items-end md:gap-10 mb-10 md:mb-16">
            <div className="md:w-7/12">
              <h1 className="md:text-5xl font-semibold text-center md:text-left text-3xl mb-4">
                {t("fHeading")}
              </h1>

              <p className="text-sm md:text-lg text-[#A6A6A6] text-center md:text-left">
                {t("fSubHeading")}
              </p>
            </div>

            <div className="text-center mt-6 md:mt-0">
              <a href="/demo">
                <button className="mx-auto px-5 py-3 text-white rounded-full bg-gradient-to-r from-[#B588FF] to-[#8B5FFF] transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:from-[#A576FF] hover:to-[#7A4EFF] active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-300">
                  {t("trailBtn")}
                </button>
              </a>
            </div>
          </div>

          {/* Section Card */}
          <div className="flex justify-between items-stretch md:flex-row flex-col gap-8 md:gap-8">
            {featuresData?.map(({ id, img, title, desc }) => (
              <div
                key={id}
                className="w-full bg-white rounded-2xl shadow-md hover:shadow-xl border border-gray-100 p-6 transform transition-all duration-300 hover:-translate-y-1"
              >
                <div className="rounded-xl overflow-hidden">
                  <img src={img} alt={title} className="w-full" />
                </div>
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold my-3 md:my-5">
                    {title}
                  </h2>
                  <p className="text-base md:text-lg font-medium text-[#A6A6A6]">
                    {desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {modalVideo && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={() => setModalVideo(null)}
        >
          <div className="relative w-full h-full max-w-none max-h-none flex flex-col">
            <button
              onClick={() => setModalVideo(null)}
              className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 z-10 bg-black bg-opacity-50 rounded-full w-12 h-12 flex items-center justify-center"
            >
              ✕
            </button>
            <div className="flex-1 flex items-center justify-center">
              {modalVideo === "ai-company" && (
                <video
                  autoPlay
                  loop
                  muted
                  controls
                  className="max-w-full max-h-full"
                  style={{
                    width: "90vw",
                    height: "90vh",
                    objectFit: "contain",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <source src={publicUrl("images/unternehmensinfos-AI.mp4")} type="video/mp4" />
                  Ihr Browser unterstützt das Video-Element nicht.
                </video>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Features;
